import React from 'react';
import { BookOpenIcon, CalculatorIcon, ClipboardListIcon, GraduationCapIcon, PillIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
const ICONS = {
  book: BookOpenIcon,
  pill: PillIcon,
  clipboard: ClipboardListIcon,
  calculator: CalculatorIcon,
  shield: ShieldCheckIcon,
  cap: GraduationCapIcon
};
const TOMO_COLORS = ['bg-brand-emerald text-white', 'bg-brand-mint text-brand-petrol', 'bg-brand-petrol text-white'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-brand-petrol" data-id="element-154" data-mp="atw4om16jq5w">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-155" data-mp="5v1bcq5l6j7j">
        <p className="font-sub text-xs font-semibold uppercase tracking-widest text-brand-mint" data-id="element-156" data-mp="ksbvsp07izfe">
          La solución que estabas buscando: un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-2 font-display text-[2rem] leading-none text-white sm:text-5xl" data-id="element-157" data-mp="fre3hjlhgp06">
          6 tomos en un solo recorrido,{' '}
          <span className="text-brand-mint" data-id="element-158" data-mp="3ba8oqgyidgms">organizado desde los fundamentos.</span>
        </h2>
        <p className="mt-1 font-sub text-xs font-bold uppercase leading-tight text-brand-gold sm:text-sm" data-id="element-159" data-mp="3f9qxyfgyw39s">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-brand-ivory" data-id="element-160" data-mp="3p9hsgh5j2i9v">
          Una ruta de apoyo académico que organiza los conocimientos para
          entender qué estudiar primero, cómo relacionarlo y de qué manera
          practicar lo aprendido.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-161" data-mp="2w01loer9i20">
          {tomos.map((tomo, i) => {
          const Icon = ICONS[tomo.icon];
          return <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-xl border-2 border-brand-emerald bg-white text-left text-brand-petrol" data-id="element-162" data-mp="bvmu1kpibdix" data-mpi={i}>
                <span className={`flex w-14 flex-shrink-0 flex-col items-center justify-center gap-0.5 border-r-2 border-brand-petrol ${TOMO_COLORS[i % 3]}`} data-id="element-163" data-mp="27y000icqhcge">
                  <span className="font-sub text-[10px] font-bold uppercase tracking-wider" data-id="element-164" data-mp="2hvwar91re5dz">
                    Tomo
                  </span>
                  <span className="font-display text-4xl leading-none" data-id="element-165" data-mp="2vlzpzg280ytx">
                    {i + 1}
                  </span>
                  <Icon size={13} aria-hidden="true" data-id="element-166" data-mp="2rlfv6j54e7ay" />
                </span>
                <div className="p-2.5" data-id="element-167" data-mp="35k5s9yrxw6zb">
                  <h3 className="font-sub text-sm font-bold uppercase leading-tight" data-id="element-168" data-mp="35j4e3lfmn4dd">
                    <span className="sr-only" data-id="element-169" data-mp="30kay9mcvb1a1">Tomo {i + 1} — </span>
                    {tomo.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-170" data-mp="168csxvhoipjf">
                    {tomo.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-171" data-mp="3mv2mvb6esqhe">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}